module.exports = __webpack_public_path__ + "static/media/google-play-badge.e3ea015c.svg";